import React from "react";
import "./EvaluationBar.css";
import { useGlobalContext } from "../context";

const EvaluationBar = ({ size }) => {
  const { boardOrientation, stockfishEvaluation, mateSoon } =
    useGlobalContext();

  // evaluation bar values in range [-20, 20]
  const checkValue = (value) => {
    if (value < -20) {
      return -20;
    }
    if (value > 20) {
      return 20;
    }
    return value;
  };

  return (
    <div className="evaluation-bar" style={{ height: `${size}px` }}>
      {boardOrientation === "white" ? (
        <>
          <div className="bar-value val-20">+20</div>
          <div className="bar-value val-10">+10</div>
          <div className="bar-value val-0"></div>
          <div className="bar-value val--10">-10</div>
          <div className="bar-value val--20">-20</div>
        </>
      ) : (
        <>
          <div className="bar-value val-20">-20</div>
          <div className="bar-value val-10">-10</div>
          <div className="bar-value val-0"></div>
          <div className="bar-value val--10">+10</div>
          <div className="bar-value val--20">+20</div>
        </>
      )}

      <div
        className={
          boardOrientation === "white"
            ? "evaluation-bar-value"
            : "evaluation-bar-value orientation-black"
        }
        style={
          mateSoon !== null
            ? { height: `${mateSoon * 100}%` }
            : { height: `${50 + checkValue(stockfishEvaluation) * 2.5}%` }
        }
      >
        {stockfishEvaluation > -19 ? stockfishEvaluation : <p></p>}
      </div>
    </div>
  );
};

export default EvaluationBar;
